import { Check, Star } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { services } from '../mock';

export const Services = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Only show Standard Build and Repair & Support
  const displayedServices = services.filter(service => 
    service.id === 1 || service.id === 3
  );

  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600">
            From standard builds to repairs, I offer quality PC services 
            tailored to your needs and budget.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {displayedServices.map((service) => (
            <Card
              key={service.id}
              className={`relative hover:shadow-xl transition-all duration-300 hover:-translate-y-2 ${
                service.popular ? 'border-2 border-amber-500 shadow-lg' : 'border border-gray-200'
              }`}
            >
              {service.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10">
                  <div className="bg-amber-600 text-white px-4 py-1 rounded-full text-sm font-semibold flex items-center gap-1 shadow-lg">
                    <Star className="w-4 h-4 fill-current" />
                    Most Popular
                  </div>
                </div>
              )}

              <CardHeader className="text-center pb-6">
                <CardTitle className="text-2xl font-bold text-gray-900 mb-2">
                  {service.title}
                </CardTitle>
                <div className="text-4xl font-bold text-amber-600 mb-2">
                  {service.price}
                </div>
                <CardDescription className="text-gray-600">
                  {service.description}
                </CardDescription>
              </CardHeader>

              <CardContent>
                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start gap-3">
                      <Check className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  onClick={() => scrollToSection('contact')}
                  className={`w-full ${
                    service.popular
                      ? 'bg-amber-600 hover:bg-amber-700 text-white'
                      : 'bg-gray-900 hover:bg-gray-800 text-white'
                  }`}
                >
                  Contact Me
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Custom Build Note */}
        <div className="mt-12 max-w-3xl mx-auto bg-amber-50 border border-amber-200 rounded-2xl p-6 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-2">Need a Custom Build?</h3>
          <p className="text-gray-700">
            Looking for a high-end gaming rig, workstation, or specialty build? I'd be happy to discuss 
            your custom requirements. Each custom build receives personalized attention to ensure it meets 
            your exact specifications.{' '}
            <button
              onClick={() => scrollToSection('contact')}
              className="text-amber-600 font-semibold hover:text-amber-700 underline"
            >
              Contact me for a quote
            </button>
          </p>
        </div>
      </div>
    </section>
  );
};